var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "label_component" }, [
    _c(
      "div",
      {
        staticClass: "left_right_icon left",
        on: { click: () => _vm.toRight(1) },
      },
      [
        _c("a-icon", {
          staticStyle: { color: "#168DFF" },
          attrs: { type: "left" },
        }),
      ],
      1
    ),
    _c("div", { ref: "labelComponent", staticClass: "content_box" }, [
      _c(
        "ul",
        {
          ref: "allLabelBox",
          staticClass: "all_label_box",
          style: { left: `${_vm.left}px` },
        },
        _vm._l(_vm.labelList, function (label, index) {
          return label.title !== "欢迎页"
            ? _c(
                "li",
                {
                  key: index,
                  staticClass: "label_box",
                  class: { select: _vm.$route.name === label.name },
                  on: {
                    click: function ($event) {
                      return _vm.onclick(label)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "label_box_title" }, [
                    _c("span", [_vm._v(_vm._s(label.title))]),
                  ]),
                  _c("a-icon", {
                    attrs: { type: "close" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.onRemove(index, label.name)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e()
        }),
        0
      ),
    ]),
    _c(
      "div",
      {
        staticClass: "left_right_icon right",
        on: { click: () => _vm.toLeft(1) },
      },
      [
        _c("a-icon", {
          staticStyle: { color: "#168DFF" },
          attrs: { type: "right" },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }